import React, { useState, useEffect } from 'react';
import BackButton from './BackButton';
import LevelingPotion from './images/LevelingPotion.png';
import BasicAnt from './images/BasicAnt.png';
import AntFood from './images/AntFood.png';
import Purse from './images/Purse.png';
import LotteryTicket from './images/LotteryTicket.png';
import LevelingPotionPopup from './LevelingPotionPopup';
import BasicAntPopup from './BasicAntPopup';
import AntFoodPopup from './AntFoodPopup';
import PursePopup from './PursePopup';
import LotteryTicketPopup from './LotteryTicketPopup';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function Shop({ goBack }) {
  const [selectedShopItem, setSelectedShopItem] = useState(null);
  const { buyTokenFromShop, buyRandomTokenFromPurse } = useSolanaWeb3();

  const [antShopMintInfo, setAntShopMintInfo] = useState(null);

  useEffect(() => {
    // Fetch or define the mint information for your Solana tokens
    const fetchedMintInfo = {
      // Example structure, update with actual data
      levelingPotion: { mintAddress: '...', price: 2 },
      antFood: { mintAddress: '...', price: 40 },
      basicAnt: { mintAddress: '...', price: 20 },
      purse: { mintAddress: '...', price: 2 },
      lotteryTicket: { mintAddress: '...', price: 4 },
      // ... other tokens
    };
    setAntShopMintInfo(fetchedMintInfo);
  }, []);

  const handleShopItemClick = (item) => {
    setSelectedShopItem(item);
  };
  
  return (
    <section id="nestwars">
      <div className="newui-container">
      <div className="platform-container">
          <div className="shopitem-container">
            <button className="shopitem-small" onClick={() => handleShopItemClick('levelingPotion')}>
              <div className="ellipse-black"></div>
              <div className="circle"></div>
              <div className="shopitem-small-text"><h2>LEVELING POTION</h2></div>
              <div className="shopitem-image"><img src={LevelingPotion} alt="Leveling Potion" /></div>
              <div className="shopitem-small-text">
              <h1 className="price">{antShopMintInfo && antShopMintInfo.levelingPotion.price}</h1>
              <p>$</p>
              </div>
            </button>
            <button className="shopitem-small" onClick={() => handleShopItemClick('antFood')}>
            <div className="ellipse-black"></div>
              <div className="circle"></div>
              <div className="shopitem-small-text"><h2>ANT FOOD</h2></div>
              <div className="shopitem-image"><img src={AntFood} alt="Ant Food" /></div>
              <div className="shopitem-small-text">
              <h1 className="price">{antShopMintInfo && antShopMintInfo.antFood.price}</h1>
              <p>Cent</p>
              </div>
            </button>
          </div>
          <div className="shopitem-container">
            <button className="shopitem-big" onClick={() => handleShopItemClick('basicAnt')}>
            <div className="circle-big"></div>
            <div className="shopitem-small-text"><h2>BASIC ANT</h2></div>
              <div className="shopitem-image-big"><img src={BasicAnt} /></div>
              <div className="shopitem-small-text"><h1 className="price">{antShopMintInfo && antShopMintInfo.basicAnt.price}</h1>
              <p>$</p>
              </div>        
            </button>
          </div>
          <div className="shopitem-container">
            <button className="shopitem-small" onClick={() => handleShopItemClick('purse')}>
            <div className="ellipse-black"></div>
            <div className="circle"></div>
            <div className="shopitem-small-text"><h2>TREASURE BOX</h2></div>
              <div className="shopitem-image"><img src={Purse} /></div>
              <div className="shopitem-small-text">
              <h1 className="price">{antShopMintInfo && antShopMintInfo.purse.price}</h1>
              <p>$</p>
              </div> 
            </button>
            <button className="shopitem-small" onClick={() => handleShopItemClick('lotteryTicket')}>
            <div className="ellipse-black"></div>
            <div className="circle"></div>
            <div className="shopitem-small-text"><h2>LOTTERY TICKET</h2></div>
              <div className="shopitem-image"><img src={LotteryTicket} /></div>
              <div className="shopitem-small-text"><h1 className="price">{antShopMintInfo && antShopMintInfo.lotteryTicket.price}</h1>
              <p>Cent</p>
              </div>
            </button>
          </div>
        </div>
      {selectedShopItem === 'levelingPotion' && <LevelingPotionPopup antShopMintInfo={antShopMintInfo ? antShopMintInfo.levelingPotion : null} onClose={() => setSelectedShopItem(null)} />}
      {selectedShopItem === 'antFood' && <AntFoodPopup antShopMintInfo={antShopMintInfo ? antShopMintInfo.antFood : null} onClose={() => setSelectedShopItem(null)} />}
      {selectedShopItem === 'basicAnt' && <BasicAntPopup antShopMintInfo={antShopMintInfo ? antShopMintInfo.basicAnt : null} onClose={() => setSelectedShopItem(null)} />}
      {selectedShopItem === 'lotteryTicket' && <LotteryTicketPopup antShopMintInfo={antShopMintInfo ? antShopMintInfo.lotteryTicket : null} onClose={() => setSelectedShopItem(null)} />}
      {selectedShopItem === 'purse' && <PursePopup antShopMintInfo={antShopMintInfo ? antShopMintInfo.purse : null} onClose={() => setSelectedShopItem(null)} />}
    </div>
    </section>
  );
}

export default Shop;
